module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/.deno/core-js@2.6.12/~/core-js/library/modules/_add-to-unscopables.js
// module id = 199
// module chunks = 0